import config from "../../config/config";
import { handleResponse } from "../../utils/handleResponse";
import { checkResponse } from "../../utils/checkResponse";
import axios from "axios"
import { authHeader } from "../../utils/authHeader";
import { handleError } from "../../utils/handleCatch";

export const productsService = { info, fetchByBarcode }

function info(barcode) {
    return (
        axios.get(`${config.baseUrl}/cli/ecommerce/products/barcode/${barcode}/info`)
            .then(handleResponse)
            .then(checkResponse)
            
    );
}

function fetchByBarcode(barcode, storeId) {
    return (
        axios.get(`${config.baseUrl}/cli/ecommerce/products/barcode/${barcode}?store=${storeId}`)
            .then(handleResponse)
            .then(checkResponse)
            
    );
}